<template>
  <a-spin :spinning="loading">
    <van-nav-bar :right-text="username" left-arrow left-text="返回" title="容器入库" @click-left="onClickLeft" @click-right="goIndex()" />
    <van-cell-group>
      <van-field ref="barcode" v-model="containerNo" autofocus clearable label="容器号" left-icon="photograph" placeholder="请扫描容器" @keyup="onBarcode" />
    </van-cell-group>
    <van-tabbar fixed placeholder>
      <van-tabbar-item>
        <van-button block round style="margin: 8px; width: 100%" type="primary" @click="confirm">确认</van-button>
      </van-tabbar-item>
    </van-tabbar>
  </a-spin>
</template>
<script>
  import debounce from 'lodash/debounce'
  import { post } from '@/api/Api'
  import { Toast } from 'vant'
  import api from '@/api'
  import { getUser } from '@/pdaView/utils'

  export default {
    data() {
      return {
        loading: false,
        username: getUser().name,
        containerNo: ''
      }
    },
    methods: {
      goIndex() {
        this.$router.push({ name: 'PdaIndex' })
      },
      onClickLeft() {
        this.$router.back()
      },
      onBarcode: debounce(function(data) {
        if ([13].includes(data.keyCode)) {
          const value = _.trim(data.target.value)
          this.save(value)
        }
      }, 300),
      save() {
        if (this.containerNo === '') {
          Toast('请输入容器号！')
          return
        }
        this.loading = true
        const args = {
          no: this.containerNo
        }
        post(api.buyingContainerSave, {}, args).then(res => {
          if (res.success) {
            Toast('入库成功！')
            this.containerNo = ''
          }
        }).finally(() => this.loading = false)
      },
      confirm() {
        this.save()
      }
    }
  }
</script>